export const MY_VEHICLE_COLOR = '#0A2442';
